import React, { useContext } from 'react';
import { Link } from 'gatsby';
import { FirebaseContext } from '@components/Firebase';
import * as ROUTES from '@utils/routes';

import styled from '@emotion/styled';
import { Container } from '@styles';

const Logo = styled(Link)`
  font-size: 1.5rem;
  color: var(--darkText);

  @media (max-width: 1140px) {
    font-size: 2vw;
  }

  @media (max-width: 767px) {
    font-size: 1.5rem;
    text-align: center;
  }

  @media (max-width: 346px) {
    font-size: 7vw;
  }

  span {
    color: var(--cta);
  }
`;

const StyledFooter = styled.footer`
  width: 100%;
  display: block;
  color: var(--darkText);

  @media (max-width: 700px) {
    margin-bottom: 5rem;
  }

  h3 {
    font-weight: bold;
    font-weight: 300;

    @media (max-width: 910px) {
      font-weight: bold;
      font-size: 1rem;
    }

    @media (max-width: 767px) {
      text-align: center;
    }
  }

  ul {
    list-style-type: none;
    padding-left: 0;
    line-height: 1.7;
    margin-top: 0;
    margin-bottom: 10px;

    @media (max-width: 768px) {
      text-align: center;
    }

    li {
      display: list-item;
      text-align: -webkit-match-parent;

      @media (max-width: 768px) {
        text-align: center;
      }

      a {
        color: var(--darkText);
        text-decoration: none;

        :hover {
          text-decoration: underline;
        }
      }
    }
  }
`;

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr repeat(4, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;

  @media (max-width: 767px) {
    grid-template-columns: 2fr;
    grid-template-rows: repeat(5, auto);
    grid-column-gap: 0px;
  }
`;

const SpecialColumn = styled.div`
  margin: auto;
`;

const StyledCopyright = styled.small`
  margin-top: 1em;
  color: var(--darkText);
  font-size: 1em;

  text-align: center !important;
`;

const FooterCopyright = styled.div`
  background-color: var(--gray);
  padding-top: 3px;
  padding-bottom: 3px;
  text-align: center;
`;

const Footer = () => {
  var d = new Date();
  var thisYear = d.getFullYear();

  const { user } = useContext(FirebaseContext);

  return (
    <StyledFooter>
      <Container normal>
        <GridWrapper>
          <SpecialColumn>
            <ul>
              <li>
                <Logo>
                  root@<span>hackersent</span>:~#
                </Logo>
              </li>
              <li>
                <StyledCopyright>a hacker brand</StyledCopyright>
              </li>
            </ul>
          </SpecialColumn>
          <div>
            <h3>Get started</h3>
            <ul>
              <li>
                <Link>Courses</Link>
              </li>
              <li>
                <Link>Pricing</Link>
              </li>
              <li>
                <Link>Members</Link>
              </li>
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
            </ul>
          </div>
          <div>
            <h3>Docs</h3>
            <ul>
              <li>
                <Link>Contact us</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy policy</Link>
              </li>
              <li>
                <Link to="/terms">Terms & Conditions</Link>
              </li>
            </ul>
          </div>
          <div>
            <h3>Account</h3>
            <ul>
              {user && (
                <>
                  <li>
                    <Link to={ROUTES.APP_PROFILE}>Profile</Link>
                  </li>
                  <li>
                    <Link to={`/app/p/${user.username}`}>Rank</Link>
                  </li>
                </>
              )}
              {!user && (
                <>
                  <li>
                    <Link to={ROUTES.LOGIN}>Login</Link>
                  </li>
                  <li>
                    <Link to={ROUTES.SIGNUP}>Signup</Link>
                  </li>
                </>
              )}
            </ul>
          </div>
          <div>
            <h3>Social</h3>
            <ul>
              <li>
                <a href="/">Facebook</a>
              </li>
              <li>
                <a href="/">Twitter</a>
              </li>
              <li>
                <a href="/">Instagram</a>
              </li>
            </ul>
          </div>
        </GridWrapper>
      </Container>
      <FooterCopyright>
        <small>
          &copy; {thisYear} Hackersent. All rights reserved. Made with{' '}
          <span role="img" aria-label="love">
            ❤️
          </span>{' '}
          in the{' '}
          <span role="img" aria-label="United States">
            🇺🇸
          </span>
          .
        </small>
      </FooterCopyright>
    </StyledFooter>
  );
};

export default Footer;
